import React, { useEffect, useState, createContext, useContext } from "react";
import { ChildContainer, Container } from "../../components/Container/Containers";
import { Banner } from "../../components/banner/Banners";
import { Breadcrumbs } from "../../components/breadcrumbs/Breadcrumbs";
import IMAGES from "../../assets/images/images";
import { Tabs } from "../../components/tabs/Tabs";
import DiameterInOutMessageGraph from "./graphs/diameter/DiameterInOutMessageGraph";
import DiameterInOutMessageBySigNodeGraph from "./graphs/diameter/DiameterInOutMessageBySigNodeGraph";
import SigtranInOutMessageGraph from "./graphs/sigtran/SigtranInOutMessageGraph";
import SigtranInOutMessageBySigNodeGraph from "./graphs/sigtran/SigtranInOutMessageBySigNodeGraph";
import {USER_TYPE} from "../../utils/constants/userConstants";
import WeatherMapPeakInOutByRouterGraph from "./graphs/weatherMaps/WeatherMapPeakInOutByRouterGraph";
import WeatherMapVolumeInOutByRouterGraph from "./graphs/weatherMaps/WeatherMapVolumeInOutByRouterGraph";
import { Graphs, subTabs } from "../../utils/constants/insightsConstants";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import WeatherMapCommonFilter from "./graphs/weatherMaps/WeatherMapCommonFilter";
import { Action, Resource } from "../../casl/constants";
import CAN from "../../casl/can";
export const WeatherMapParamsContext = createContext(null);
//import DiameterGraphs from "./graphs/DiameterGraphs";
//import SigtranGraphs from "./graphs/SigtranGraphs";
//import WeatherMapsGraphs from "./graphs/WeatherMapsGraphs";


export const DiameterGraphs=()=>{
  const params= useParams();
  let diameterMapParams={};
  if(params.hasOwnProperty('data')){
    let data=JSON.parse(decodeURIComponent(params.data));
    if (data?.inOutMessage && Object.keys(data.inOutMessage).length > 0 && data.inOutMessage.tab === Graphs.DIAMETER) {
      diameterMapParams = {
        ...diameterMapParams,
        inOutMessage: data?.inOutMessage
      };
    }
    if (data?.inOutMessageBySigNode && Object.keys(data.inOutMessageBySigNode).length > 0 && data.inOutMessageBySigNode.tab === Graphs.DIAMETER) {
      diameterMapParams = {
        ...diameterMapParams,
        inOutMessageBySigNode: data?.inOutMessageBySigNode
      };
    }
  }
  return(
    <React.Fragment>
      <DiameterInOutMessageGraph params={diameterMapParams?.inOutMessage}/>
      <DiameterInOutMessageBySigNodeGraph params={diameterMapParams?.inOutMessageBySigNode}/>
    </React.Fragment>
  )
}

export const SigtranGraphs=()=>{
  const params= useParams();
  let sigtranMapParams={};
  if(params.hasOwnProperty('data')){
    let data=JSON.parse(decodeURIComponent(params.data));
    if (data?.inOutMessage && Object.keys(data.inOutMessage).length > 0 && data.inOutMessage.tab === Graphs.SIGTRAN) {
      sigtranMapParams = {
        ...sigtranMapParams,
        inOutMessage: data?.inOutMessage
      };
    }
    if (data?.inOutMessageBySigNode && Object.keys(data.inOutMessageBySigNode).length > 0 && data.inOutMessageBySigNode.tab === Graphs.SIGTRAN) {
      sigtranMapParams = {
        ...sigtranMapParams,
        inOutMessageBySigNode: data?.inOutMessageBySigNode
      };
    }
  }
  return(
    <React.Fragment>
      <SigtranInOutMessageGraph params={sigtranMapParams?.inOutMessage}/>
      <SigtranInOutMessageBySigNodeGraph params={sigtranMapParams?.inOutMessageBySigNode}/>
    </React.Fragment>
  )
}
const WeatherMapsGraphs = ({params}) => {
  return (
    <React.Fragment>
      <WeatherMapPeakInOutByRouterGraph params={params}/>
      <WeatherMapVolumeInOutByRouterGraph params={params}/>
    </React.Fragment>
  )
}

const WeatherMapsWrapper = () => {
  const weatherMapParams = useContext(WeatherMapParamsContext);

  return (
    <div>
      <WeatherMapCommonFilter params={weatherMapParams} />
      <WeatherMapsGraphs params={weatherMapParams} />
    </div>
  );
};

const Dashboard = (props) => {
  const location = useLocation();
  const pathParts = location.pathname.split("/");
  const subRoute = pathParts[2];
  const navigate = useNavigate()
  const [activeTab, setActiveTab] = useState("");
  const params= useParams();
  let weatherMapParams={};
  if(params.hasOwnProperty('data')){
    let data=JSON.parse(decodeURIComponent(params.data));
    if(data?.tab===Graphs.WEATHERMAPS){
      // weatherMapParams.service_types=data?.service_types?.toLowerCase();
      // weatherMapParams.cp_names=data?.cp_names;
      weatherMapParams = {
        ...data,
        service_types: data?.service_types?.toLowerCase() // normalize if needed
      };
    }
  }
  const breadcrumbsOption = [
    { label: "Insights", link: "" }
  ];
  const tabOption = [
    {
      key: Graphs.WEATHERMAPS,
      label: "IP Link Utilization",
      canAccess: CAN(Action.GET, Resource.WEATHERMAPS),
      routeUrl:'/insights/ipLinkUtilization'
    },
    {
      key: Graphs.DIAMETER,
      label: "Diameter",
      canAccess: CAN(Action.GET, Resource.DIAMETER),
      routeUrl:'/insights/diameter'
    },
    {
      key: Graphs.SIGTRAN,
      label: "Sigtran",
      canAccess: CAN(Action.GET, Resource.SIGTRAN),
      routeUrl:'/insights/sigtran'
    }
  ];
  const getActiveTab = (tab) => {
    setActiveTab(tab);
  }

  useEffect(()=>{
    let cp_name=props.myRights?.cpName;
    let  userType =props.myRights?.userType;
    if(userType==USER_TYPE.INTERNAL){
      props.getDiaFinalTypeandFinalDist(cp_name);
      props.getSigFinalTypeandFinalDist(cp_name);

    }else{
      props.getDiaSigNodeandConectionId(cp_name);
      props.getSigSigNodeandConectionId(cp_name);

    }
    props.getWeatherMapFiltersValue(cp_name);
  },[])

  return (
    <Container>
      <Banner image={IMAGES.vfbanner} text={"Insights"}></Banner>
      {/*<ChildContainer>
        <Breadcrumbs options={breadcrumbsOption} />
  </ChildContainer>*/}
      <Tabs option={tabOption} defaultActiveTab={subTabs[subRoute]} getActiveTab={getActiveTab} />
      <WeatherMapParamsContext.Provider value={weatherMapParams}>
      <ChildContainer>
        {/* {
          activeTab===Graphs.DIAMETER?
          <DiameterGraphs/>:
          activeTab===Graphs.SIGTRAN?
          <SigtranGraphs/>:
          activeTab===Graphs.WEATHERMAPS?
          <div>
          <WeatherMapCommonFilter params={weatherMapParams}/>
          <WeatherMapsGraphs params={weatherMapParams}/></div>
          :<></>
        } */}
        <Outlet/>
      </ChildContainer>
      </WeatherMapParamsContext.Provider>
    </Container>
  )
};

export default Dashboard;
export { WeatherMapsWrapper };
